function e(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, o);
  }

  return n;
}

function t(t) {
  for (var n = 1; n < arguments.length; n++) {
    var r = null != arguments[n] ? arguments[n] : {};
    n % 2 ? e(Object(r), !0).forEach(function (e) {
      o(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : e(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

function n(e) {
  return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function o(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function r(e) {
  return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function a(e, t) {
  var n;
  if ("function" != typeof (n = t.domElement ? function () {
    return t.domElement;
  } : t.domElementGetter ? t.domElementGetter : e.domElementGetter ? e.domElementGetter : function (e) {
    var t = e.appName || e.name;
    if (!t) throw Error("single-spa's dom-element-getter-helpers was not given an application name as a prop, so it can't make a unique dom element container for the react application");
    var n = "single-spa-application:".concat(t);
    return function () {
      var e = document.getElementById(n);
      return e || ((e = document.createElement("div")).id = n, document.body.appendChild(e)), e;
    };
  }(t))) throw Error("single-spa's dom-element-getter-helpers was given an invalid domElementGetter for application or parcel '".concat(t.name, "'. Expected a function, received ").concat(r(n)));
  return function () {
    var e = n(t);
    if (!(e instanceof HTMLElement)) throw Error("single-spa's dom-element-getter-helpers: domElementGetter returned an invalid dom element for application or parcel '".concat(t.name, "'. Expected HTMLElement, received ").concat(r(e)));
    return e;
  };
}

var i = null;

try {
  i = require("react").createContext();
} catch (e) {}

var c = {
  React: null,
  ReactDOM: null,
  rootComponent: null,
  loadRootComponent: null,
  renderType: null,
  errorBoundary: null,
  errorBoundaryClass: null,
  domElementGetter: null,
  parcelCanUpdate: !0,
  suppressComponentDidCatchWarning: !1,
  domElements: {},
  renderResults: {},
  updateResolves: {}
};

function u(e) {
  if ("object" !== n(e)) throw new Error("single-spa-react requires a configuration object");
  var o = t(t({}, c), e);
  if (!o.React) throw new Error("single-spa-react must be passed opts.React");
  if (!o.ReactDOM) throw new Error("single-spa-react must be passed opts.ReactDOM");
  if (!o.rootComponent && !o.loadRootComponent) throw new Error("single-spa-react must be passed opts.rootComponent or opts.loadRootComponent");
  if (o.errorBoundary && "function" != typeof o.errorBoundary) throw Error("The errorBoundary opt for single-spa-react must either be omitted or be a function that returns React elements");
  !i && o.React.createContext && (i = o.React.createContext()), o.SingleSpaRoot = function (e) {
    function t(e) {
      t.displayName = "SingleSpaRoot(".concat(e.name, ")");
    }

    return t.prototype = Object.create(e.React.Component.prototype), t.prototype.componentDidMount = function () {
      setTimeout(this.props.mountFinished);
    }, t.prototype.componentWillUnmount = function () {
      setTimeout(this.props.unmountFinished);
    }, t.prototype.render = function () {
      return setTimeout(this.props.updateFinished), this.props.children;
    }, t;
  }(o);
  var r = {
    bootstrap: p.bind(null, o),
    mount: s.bind(null, o),
    unmount: l.bind(null, o)
  };
  return o.parcelCanUpdate && (r.update = m.bind(null, o)), r;
}

function p(e, t) {
  return e.rootComponent ? Promise.resolve() : e.loadRootComponent(t).then(function (t) {
    e.rootComponent = t;
  });
}

function s(e, t) {
  return new Promise(function (n, o) {
    e.suppressComponentDidCatchWarning || !function (e) {
      if (!(e && "string" == typeof e.version && e.version.indexOf(".") >= 0)) return !1;
      var t = e.version.slice(0, e.version.indexOf("."));

      try {
        return Number(t) >= 16;
      } catch (e) {
        return !1;
      }
    }(e.React) || e.errorBoundary || (e.rootComponent.prototype ? e.rootComponent.prototype.componentDidCatch || console.warn("single-spa-react: ".concat(t.name || t.appName || t.childAppName, "'s rootComponent should implement componentDidCatch to avoid accidentally unmounting the entire single-spa application.")) : console.warn("single-spa-react: ".concat(t.name || t.appName || t.childAppName, "'s rootComponent does not implement an error boundary.  If using a functional component, consider providing an opts.errorBoundary to singleSpaReact(opts).")));

    var r = d(e, t, function () {
      n(this);
    }),
        i = a(e, t)(),
        c = function (e) {
      var t = e.opts,
          n = e.elementToRender,
          o = e.domElement,
          r = "function" == typeof t.renderType ? t.renderType() : t.renderType;

      if (["createRoot", "unstable_createRoot", "createBlockingRoot", "unstable_createBlockingRoot"].indexOf(r) >= 0) {
        var a = t.ReactDOM[r](o);
        return a.render(n), a;
      }

      "hydrate" === r ? t.ReactDOM.hydrate(n, o) : t.ReactDOM.render(n, o);
      return null;
    }({
      elementToRender: r,
      domElement: i,
      opts: e
    });

    e.domElements[t.name] = i, e.renderResults[t.name] = c;
  });
}

function l(e, t) {
  return new Promise(function (n) {
    e.unmountFinished = n;
    var o = e.renderResults[t.name];
    o && o.unmount ? o.unmount() : e.ReactDOM.unmountComponentAtNode(e.domElements[t.name]), delete e.domElements[t.name], delete e.renderResults[t.name];
  });
}

function m(e, t) {
  return new Promise(function (n) {
    e.updateResolves[t.name] || (e.updateResolves[t.name] = []), e.updateResolves[t.name].push(n);
    var o = d(e, t, null),
        r = e.renderResults[t.name];
    if (r && r.render) r.render(o);else {
      var i = a(e, t)();
      e.ReactDOM.render(o, i);
    }
  });
}

function d(e, n, o) {
  var r = e.React.createElement(e.rootComponent, n),
      a = i ? e.React.createElement(i.Provider, {
    value: n
  }, r) : r;
  return (e.errorBoundary || n.errorBoundary || e.errorBoundaryClass || n.errorBoundaryClass) && (e.errorBoundaryClass = e.errorBoundaryClass || n.errorBoundaryClass || function (e, t) {
    function n(t) {
      e.React.Component.apply(this, arguments), this.state = {
        caughtError: null,
        caughtErrorInfo: null
      }, n.displayName = "SingleSpaReactErrorBoundary(".concat(t.name, ")");
    }

    return n.prototype = Object.create(e.React.Component.prototype), n.prototype.render = function () {
      return this.state.caughtError ? (e.errorBoundary || t.errorBoundary)(this.state.caughtError, this.state.caughtErrorInfo, this.props) : this.props.children;
    }, n.prototype.componentDidCatch = function (e, t) {
      this.setState({
        caughtError: e,
        caughtErrorInfo: t
      });
    }, n;
  }(e, n), a = e.React.createElement(e.errorBoundaryClass, n, a)), a = e.React.createElement(e.SingleSpaRoot, t(t({}, n), {}, {
    mountFinished: o,
    updateFinished: function () {
      e.updateResolves[n.name] && (e.updateResolves[n.name].forEach(function (e) {
        return e();
      }), delete e.updateResolves[n.name]);
    },
    unmountFinished: function () {
      setTimeout(e.unmountFinished);
    }
  }), a);
}

export { i as SingleSpaContext, u as default };